import { useState, useEffect, useCallback, useRef } from "react";

import {
  UserBasic,
  UserBasicFromJSON,
} from "../bitmaker/schemas/Users/UserBasic";
import { useApiError } from "./useApiError";
import { BitmakerAPIClient } from "../services/BitmakerApp";

export const useActiveUsers = () => {
  const [users, setUsers] = useState<UserBasic[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [fetchUsersError, setFetchUsersError] = useState<string | null>(null);

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchUsers = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingUsers(true);
    setFetchUsersError(null);

    BitmakerAPIClient.get("/users/active", {}, (response: any) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching users:", message);
        setFetchUsersError("Error fetching users. Please try again.");
        setLoadingUsers(false);
        return;
      }

      const data = Array.isArray(response.data) ? response.data : [];
      setUsers(data.map(UserBasicFromJSON));
      setLoadingUsers(false);
    });
  }, [handleAPIError]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return {
    users,
    loadingUsers,
    fetchUsersError,
    refetchUsers: fetchUsers,
  };
};
